import { Assert } from '@team/assert';
import { ImageSources } from '../../types';

export const getImagePathByPixelRatio = (
  { base, x2, x3, x4 }: ImageSources,
  ratio: number
) => {
  if (ratio >= 3.5 && Assert.isString(x4)) {
    return x4;
  }

  if (ratio >= 2.5 && Assert.isString(x3)) {
    return x3;
  }

  if (ratio >= 1.5 && Assert.isString(x2)) {
    return x2;
  }

  return base;
};
